import { debug } from "../config";

/* eslint-disable require-jsdoc */
/* eslint-disable require-jsdoc */


var options = {
  enableHighAccuracy: true,
  timeout: 2000,
  maximumAge: 0
};

function success(pos) {
  window.changePowersearchLoc(pos.coords.latitude, pos.coords.longitude);
}

function error(err) {
  console.warn(`ERROR(${err.code}): ${err.message}`);
}

function useGeolocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      success(position);
  }, error, options);
  } else {
    debug && console.log('no navigator');
  }
};

function getPosition(options) {
  return new Promise((resolve, reject) => 
      navigator.geolocation.getCurrentPosition(resolve, reject, options)
  );
}
export {useGeolocation, getPosition};